export const bgImageStripMetaData = {
    fullWidthByStructure: true,
    fullWidth: true
}
